<template>
  <div class="mode-button-wrap" v-if="mode" :style="position" @click="click">
    <span v-if="active !== mode" :style="{ fontSize }">{{ text }}</span>
    <img v-else :src="btn" :width="imgWidth" />
  </div>
</template>

<script>
import { get } from '@/components/virtualPhone/data/resource';

export default {
  props: {
    mode: {
      type: String,
      default: ''
    },
    active: {
      type: String,
      default: ''
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  inject: ['calc'],
  data() {
    return {
      imgs: {
        quick: get('quick'),
        simple: get('simple'),
        deep: get('deep'),
        plus: get('plus')
      },
      texts: {
        quick: '快速模式',
        simple: '精简模式',
        deep: '深色模式',
        plus: '增强模式'
      },
      positions: {
        quick: ['left', 'top'],
        simple: ['left', 'bottom'],
        deep: ['right', 'top'],
        plus: ['right', 'bottom']
      }
    };
  },
  computed: {
    btn() {
      return this.imgs[this.mode];
    },
    text() {
      return this.texts[this.mode];
    },
    position() {
      const obj = {};
      this.positions[this.mode].forEach(e => {
        obj[e] = this.calc(43.199, 'px');
      });
      return obj;
    },
    imgWidth() {
      return this.calc(172.79, 'px');
    },
    fontSize() {
      return this.calc(28.8, 'px');
    }
  },
  methods: {
    click() {
      if (this.enabled) this.$emit('switch', this.mode);
    }
  }
};
</script>

<style lang="scss" scoped>
.mode-button-wrap {
  position: absolute;
  cursor: pointer;
  span {
    color: #e2e2e2;
  }
}
</style>
